import { render, staticRenderFns } from "./CardWelcome.vue?vue&type=template&id=064dfe48&scoped=true&"
import script from "./CardWelcome.vue?vue&type=script&lang=js&"
export * from "./CardWelcome.vue?vue&type=script&lang=js&"
import style0 from "./CardWelcome.vue?vue&type=style&index=0&id=064dfe48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064dfe48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VContainer})
